import axiosInstance from "./axiosInstance";

export function create(param) {
  return axiosInstance.post('lawyer/add',param)
}

export function update(param) {
  return axiosInstance.post('lawyer/edit',param)
}

export function del(param) {
	return axiosInstance.post('lawyer/del', param)
}

export function query(param) {
  return axiosInstance.post('lawyer/query',param)
}

export function queryDetail(param) {
  return axiosInstance.post('lawyer/queryDetail',param)
}

export function upload(formData) {
	return axiosInstance.post('file/obsUploadFile', formData)
}

export function queryLawyer(param) {
  return axiosInstance.post('lawyer/query',param)
}